import { PaginationQuery } from '../models/AppPagination';
import { getAxiosInstance } from '../../react/utils/networkUtil';
import { Organization_Base } from '../models/Organization';
import { PaginationResult } from '../models/AppPagination';
import { AC_Organization_Base } from '../services/access_control/AC_Organization';
import { TLGeoProducts_RegisterInfo, TLGeoProducts_RegisterInfo_BooleanFields } from '../models/TLGeoProducts';

export type Organization_Create_Request = TLGeoProducts_RegisterInfo & TLGeoProducts_RegisterInfo_BooleanFields & {
  name: string;
  description: string;
  maxNMembers?: number;

  // Tax and identification
  taxId?: string;
  shortName?: string;
  code?: string;

  // Legal and business type
  legalType?: string;
  registrationNumber?: string;
  registrationDate?: string;

  // Contact and address
  email?: string;
  phone?: string;
  website?: string;
  addressLine?: string;
  city?: string;
  country?: string;
  postalCode?: string;

  // Activity and status
  industry?: string;
  foundedDate?: string;
  status?: string;
};

export type Organization_GetPage_RequestQuery = PaginationQuery & {
  phone_number?: string;
  user_id?: number;
};
const remote_getPage = async (
  request: Organization_GetPage_RequestQuery,
): Promise<PaginationResult<Organization_Base>> => {
  return (await getAxiosInstance().get('/api/organizations-ext', { params: request })).data;
};

const remote_getMyOrg = async (): Promise<Organization_Base[]> => {
  return (await getAxiosInstance().get('/api/organizations-ext/me')).data;
};

const remote_getSharedOrg = async (): Promise<AC_Organization_Base[]> => {
  return (await getAxiosInstance({ hideSystemError: true }).get('/api/organizations-ext/shared')).data;
};

export type Organization_GetOne_Response = Organization_Base & {
  memberWithRoles: AC_Organization_Base[];
};
const remote_getOne = async (id: number): Promise<Organization_GetOne_Response> => {
  return (await getAxiosInstance().get(`/api/organizations-ext/${id}`)).data;
};

const remote_create = async (request: Organization_Create_Request) => {
  return (await getAxiosInstance().post('/api/organizations-ext', request)).data;
};


export type Organization_Update_Request = Organization_Create_Request & {
  owner_id?: number;
};
const remote_update = async (id: number, request: Organization_Update_Request) => {
  return (await getAxiosInstance().put(`/api/organizations-ext/update/${id}`, request)).data;
};

const remote_leaveOrganization = async (id: number) => {
  return (await getAxiosInstance().delete(`/api/organizations-ext/leave/${id}`)).data;
};

const remote_removeMember = async (organizationDocumentID: string, userDocumentID: string) => {
  return (await getAxiosInstance().delete(`/api/organizations-ext/remove-member/${organizationDocumentID}/${userDocumentID}`)).data;
};

const remote_delete = async (id: number) => {
  return (await getAxiosInstance().delete(`/api/organizations-ext/${id}`)).data;
};

export const OrganizationAPIs = {
  remote_getPage,
  remote_getMyOrg,
  remote_getSharedOrg,

  remote_getOne,
  remote_create,
  remote_update,
  remote_delete,
  remote_leaveOrganization,
  remote_removeMember,
};
